<div class="container-fluid mt-3">
    <div class="card">
        <div class="card-header d-flex align-items-center">
            <strong>{{ 'kobeac.notification_management' | transloco }}</strong>
            <button class="btn btn-sm btn-primary ml-auto" (click)="newItem()">{{ 'kobeac.create_new' | transloco }}</button>
        </div>
        <div class="card-body">
            <!-- 一覧 -->
            <table class="table table-sm table-hover">
                <thead>
                <tr>
                    <th style="width:160px">{{ 'kobeac.datetime' | transloco }}</th>
                    <th style="width:120px">{{ 'kobeac.category' | transloco }}</th>
                    <th>{{ 'kobeac.subject' | transloco }}</th>
                    <th style="width:140px">{{ 'kobeac.target' | transloco }}</th>
                    <th style="width:80px">{{ 'kobeac.state' | transloco }}</th>
                    <th style="width:120px">{{ 'kobeac.actions' | transloco }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let n of list" [class.text-muted]="n.active === false">
                    <td>{{ formatDateTime(n.notifyDate) }}</td>
                    <td><span class="badge badge-info">{{ n.category || 'お知らせ' }}</span></td>
                    <td>{{ n.subject }}</td>
                    <td>{{ targetLabel(n) }}</td>
                    <td>
                        <span class="badge" [class.badge-success]="n.active !== false" [class.badge-secondary]="n.active === false">
                            {{ (n.active === false ? 'kobeac.inactive' : 'kobeac.active') | transloco }}
                        </span>
                    </td>
                    <td>
                        <button class="btn btn-sm btn-link p-0 mr-2" (click)="edit(n)">{{ 'common.edit' | transloco }}</button>
                        <button class="btn btn-sm btn-link p-0 text-danger" (click)="remove(n)">{{ 'common.delete' | transloco }}</button>
                    </td>
                </tr>
                <tr *ngIf="!loading && list.length === 0">
                    <td colspan="6" class="text-muted">{{ 'kobeac.no_notifications' | transloco }}</td>
                </tr>
                </tbody>
            </table>

            <!-- 編集フォーム -->
            <div *ngIf="editing" class="border rounded p-3 mt-3">
                <h6 class="mb-3">{{ (editing.rid ? 'kobeac.edit_notification' : 'kobeac.new_notification') | transloco }}</h6>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label>{{ 'kobeac.category' | transloco }}</label>
                        <select class="form-control" [(ngModel)]="editing.category">
                            <option *ngFor="let c of categoryOptions" [value]="c">{{ c }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-8">
                        <label>{{ 'kobeac.subject' | transloco }}</label>
                        <input type="text" class="form-control" [(ngModel)]="editing.subject" [placeholder]="'kobeac.subject' | transloco">
                    </div>
                </div>
                <div class="form-group">
                    <label>{{ 'kobeac.body' | transloco }}</label>
                    <editor [(ngModel)]="editing.content" [ngModelOptions]="{standalone: true}" [init]="tinymceConfig"></editor>
                </div>
                <div class="form-group">
                    <label class="mr-3">{{ 'kobeac.target' | transloco }}</label>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" id="targetAll" [value]="true" [(ngModel)]="editing.targetAll">
                        <label class="form-check-label" for="targetAll">{{ 'kobeac.all_customers' | transloco }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" id="targetSel" [value]="false" [(ngModel)]="editing.targetAll">
                        <label class="form-check-label" for="targetSel">{{ 'kobeac.specific_customers' | transloco }}</label>
                    </div>
                </div>

                <!-- 顧客指定 -->
                <div class="form-group" *ngIf="!editing.targetAll">
                    <label>{{ 'kobeac.target_customers_n' | transloco: {count: selectedCount} }}</label>
                    <input type="text" class="form-control form-control-sm mb-2" [(ngModel)]="customerFilter" [placeholder]="'kobeac.filter_customer_placeholder' | transloco">
                    <div class="border rounded" style="max-height:220px; overflow:auto">
                        <div class="form-check px-3 py-1" *ngFor="let c of filteredCustomers">
                            <input class="form-check-input" type="checkbox" [id]="'c_' + c['@rid']"
                                   [checked]="selected[c['@rid']]" (change)="toggle(c['@rid'])">
                            <label class="form-check-label" [for]="'c_' + c['@rid']">{{ c['ID'] }} {{ c['名称'] }}</label>
                        </div>
                    </div>
                    <small class="text-muted">{{ 'kobeac.first_200_hint' | transloco }}</small>
                </div>

                <!-- 有効/無効 (無効にすると全ユーザのお知らせから除外) -->
                <div class="form-group">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="notifActive" [(ngModel)]="editing.active">
                        <label class="form-check-label" for="notifActive">
                            {{ 'kobeac.show_this_notification' | transloco }}
                            <small class="text-muted">{{ 'kobeac.off_hint' | transloco }}</small>
                        </label>
                    </div>
                </div>

                <button class="btn btn-primary" [disabled]="saving" (click)="save()">{{ (saving ? 'kobeac.saving' : 'common.save') | transloco }}</button>
                <button class="btn btn-secondary ml-2" (click)="cancel()">{{ 'common.cancel' | transloco }}</button>
            </div>
        </div>
    </div>
</div>
